export const AppConfig = {
  AppType: 'web',
  TableSize: 1000,
  EmptyGuid: '00000000-0000-0000-0000-000000000000',
};

export enum Operators {
  Equals = 1,
  GreaterThan = 2,
  LessThan = 3,
  GreaterThanOrEqual = 4,
  LessThanOrEqual = 5,
  Contains = 6,
  StartsWith = 7,
  EndsWith = 8,
  NotEquals = 9,
}

export enum UomConversionOperator {
  Multiply = 1,
  Diide = 2,
}

export enum SortingType {
  Asc = 1,
  Desc = 2,
}

export enum ResponseType {
  Success = 1,
  Validation = 2,
  Error = 3,
  Security = 4,
}

export enum AndOrCondition {
  And = 1,
  Or = 2,
}

export enum StorageKey {
  AuthToken = '@authtoken',
  RefreshToken = '@refreshtoken',
  Menus = '@menus',
  AdminMenus = '@adminmenus',
  User = '@user',
}

export enum UserType {
  SuperAdmin = 1,
  ClientAdmin = 2,
  User = 3
}

export enum AppSettings {
  AppType = 'WebApp',
  ResourceClientId = 'e4dde6ce-2cda-4fd2-a601-abd83f3a0ea1',
  DateFormat = 'yyyy-MM-ddTHH:mm:ss',
  FromDateFilterPropertyName="FromDate",
  ToDateFilterPropertyName="ToDate"
}
